import React from 'react';

const SvgUg = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="UG_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="UG_svg__b" fill="#fff">
        <use xlinkHref="#UG_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#UG_svg__a" />
      <path
        fill="#262626"
        mask="url(#UG_svg__b)"
        d="M0 0h28v2.667H0zM0 10.667h28v2.667H0z"
      />
      <path fill="#ED1623" mask="url(#UG_svg__b)" d="M0 6.667h28v4H0z" />
      <path fill="#FEE044" mask="url(#UG_svg__b)" d="M0 2.667h28v4H0z" />
      <path fill="#ED1623" mask="url(#UG_svg__b)" d="M0 17.333h28V20H0z" />
      <path fill="#FEE044" mask="url(#UG_svg__b)" d="M0 13.333h28v4H0z" />
      <circle fill="#FFF" mask="url(#UG_svg__b)" cx={14} cy={10} r={4.667} />
      <path
        d="M12.907 7.574a.337.337 0 0 1 0-.481l.186-.186c.133-.133.337-.361.464-.496l.15-.119c.162.023.409-.045.59-.016l.158.123c.117.148.145.4.064.564l-.371.741c-.082.164-.148.45-.148.63 0 .183.133.399.296.48l.741.371c.164.082.401.253.529.38l.868.87a.488.488 0 0 1 .085.528l-.371.741c-.082.164-.252.192-.389.055l-.185-.185a.337.337 0 0 0-.481 0l-.186.185a.947.947 0 0 0-.24.574c0 .184.104.438.24.574l.186.186c.133.133.083.24-.09.24h-1.34c-.182 0-.226-.104-.089-.24l.185-.186a.947.947 0 0 0 .241-.574.337.337 0 0 0-.333-.333.922.922 0 0 0-.574.24l-.186.186a.337.337 0 0 1-.481 0l-.185-.185a.337.337 0 0 1 0-.482l.185-.185a.92.92 0 0 1 .577-.24h.66c.186 0 .23-.108.108-.23l-1.542-1.541a.327.327 0 0 1 .003-.462l.87-.869a.331.331 0 0 0-.01-.473l-.185-.185z"
        fill="#262626"
        mask="url(#UG_svg__b)"
      />
    </g>
  </svg>
);

export default SvgUg;
